export const PopupIconType = {
    DEFAULT: 'default',
    IMPORTANT: 'important',
    MAINTENANCE: 'maintenance',
    UPDATE: 'update',
    EVENT: 'event',
    TIP: 'tip',
    SECURITY: 'security',
};

export const PopupIconLabel = {
    default: '공지',
    important: '중요',
    maintenance: '점검',
    update: '업데이트',
    event: '이벤트',
    tip: '팁',
    security: '보안',
};

export const PopupIconColor = {
    default: 'default',
    important: 'red',
    maintenance: 'orange',
    update: 'blue',
    event: 'magenta',
    tip: 'green',
    security: 'purple',
};
